/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Found_TitleInputs */



/**
* | output |
* | --- |
* | "In this file" |
*
* @param {Subtitle_Extract_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_found_title = /** @type {((inputs?: Subtitle_Extract_Found_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Found_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans ce fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("In questo file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом файле")
	if (locale === "es") return /** @type {LocalizedString} */ ("En este archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在这个文件中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このファイルでは")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस फ़ाइल में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Neste arquivo")
	return /** @type {LocalizedString} */ ("In this file")
});